import { POSTER_LOADED } from '../actions/types';

const initialState = {
  isPosterReady: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case POSTER_LOADED:
      return { ...state, isPosterReady: true };
    default:
      return state;
  }
};
